import { Typography } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import ResponsiveContainer from '../../../../components/ResponsiveContainer';
import { useInspeccionContext } from '../../../../context/inspeccion-context';
import { cards } from '../../CarUtil';
import Tarjeta from './Tarjeta';

const { Title } = Typography;

export default function Fotografias({ title, ...props }) {
  const [step, setStep] = useState(props.start ? 0 : 11);
  const { inspeccion, images } = useInspeccionContext();
  const myRef = useRef(null);
  const scrollTop = () => scrollToRef(myRef);

  const scrollToRef = (ref) => {
    if (ref && ref.current) {
      const headerOffset = 64;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = ref.current.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  function whatStep() {
    for (let index = 0; index < 12; index += 1) {
      const item = images.find((element) => element.paso_nro === index + 1);
      if (!item) {
        return index;
      }
    }
    return 12;
  }

  useEffect(() => {
    if (images.lenght !== 12) {
      if (props.continue) {
        scrollTop();
        setStep(whatStep());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const next = async () => {
    if (step === 11) {
      props.next();
    }
    setStep(step + 1);
  };

  const back = async () => {
    if (step === 0) {
      props.back();
    }
    setStep(step - 1);
  };

  const stepPages = [
    <Tarjeta
      key={1}
      card={cards[0]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={2}
      card={cards[1]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={3}
      card={cards[2]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={4}
      card={cards[3]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={5}
      card={cards[4]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={6}
      card={cards[5]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={7}
      card={cards[6]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={8}
      card={cards[7]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={9}
      card={cards[8]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={10}
      card={cards[9]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={11}
      card={cards[10]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={12}
      card={cards[11]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={13}
      card={cards[12]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={14}
      card={cards[13]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={15}
      card={cards[14]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={16}
      card={cards[15]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={17}
      card={cards[16]}
      imagenes={images}
      next={next}
      back={back}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />,
    <Tarjeta
      key={18}
      card={cards[17]}
      imagenes={images}
      next={next}
      back={back}
      finalizar={props.next}
      countPasos={18}
      inspeccion={inspeccion}
      showSiguiente
    />
  ];

  const getRender = () => {
    return (
      <>
        <ResponsiveContainer>
          <div style={{ paddingTop: 20 }}>
            <Title level={3} align="center">
              {title}
            </Title>
          </div>
          <div ref={myRef} />
          {stepPages[step]}
        </ResponsiveContainer>
      </>
    );
  };

  return getRender();
}
